import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import moment from "moment"
import { useEnvironment } from "@/hooks/useEnvironment"
import { useUtilities } from "@/hooks/useUtilities"
import Icon from "../widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Nav',
  props: {
  logoUrl: {
    type: String,
    default: "/logo_platform.svg",
  },
  width: {
    type: Number,
    default: 256,
  },
  temporary: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const drawer = ref(true)
const { collapseDrawer } = useUtilities()

const isDrawerCollapsed = () => {
  if (props.temporary) return false
  return collapseDrawer()
}

const year = computed(() => {
  return moment().year()
})

const env = computed(() => {
  const { env } = useEnvironment()
  return env
})

const isProduction = computed(() => {
  const { isProduction } = useEnvironment()
  return isProduction
})

const onMenuClicked = () => {
  if (props.disabled) return
  drawer.value = !drawer.value
}

return { __sfc: true,props, drawer, collapseDrawer, isDrawerCollapsed, year, env, isProduction, onMenuClicked, Icon }
}

})